module.exports = __webpack_public_path__ + "img/23_115.302610ea.png";